import * as React from 'react';
import { Col, Modal, Row } from 'react-bootstrap';
import  { IErrorProperties, IErrorValidation } from 'src/app/data/common/interfaces/IRestError';
import { isCancel, parseErrorProperties, parseErrorValidation, toUpperFirst } from 'src/app/data/common/utils/errorUtils';
import Button from 'src/components/Button';
import Separator from 'src/components/Separator/Separator';
import TranslateMessage from 'src/i18n/TranslateMessage';
import A11yModal from 'src/components/A11yModal';
import styles from 'src/components/ErrorModal/ErrorModal.css';
import close from "src/components/ErrorModal/images/close.svg";
import { injectIntl, WrappedComponentProps } from 'react-intl';
export interface IErrorModalProps extends WrappedComponentProps {
  errorMessage: string;
  errorValidations?: IErrorValidation[];
  errorProperties?: IErrorProperties | null;
  show: boolean;
  onConfirm?: (isCancelBtn: boolean) => void;
  onHide?: () => void;
  errorCode?: string | number;
}

class ErrorModal extends React.Component<IErrorModalProps> {
  public render() {
    const {
      errorMessage,
      errorValidations,
      errorProperties,
      show,
      intl,
      errorCode,
    } = this.props;

    const errorPropertiesValue = errorProperties && parseErrorProperties(errorProperties);

    return (
    <A11yModal show={show} onHide={this.onHide} className={styles.errorModalWrap} shouldCloseOnOverlayClick={true} size={"sm"}>
        <Modal.Body className={styles.errorMessage}>
          <button onClick={this.onHide} className={styles.closeBtn}><img src={close} alt={intl.formatMessage({id:'MursionPortal.AriaImage.Attribute.Close'})}/></button>
          {toUpperFirst(errorMessage)}
          {
            errorValidations &&
            errorValidations.map((validation, i) => {
              const message = parseErrorValidation(validation);
              return (
                <React.Fragment key={'validation-error-' + i}>
                  {i === 0 && <Separator/>}
                  <Row>
                    <Col xs={12}>{message}</Col>
                  </Row>
                </React.Fragment>
              );
            })
          }
          {
            errorPropertiesValue && 
            (
              <>
                <Separator/>
                <Row key={'properties-row'}>
                  <Col xs={12}>{errorPropertiesValue}</Col>
                </Row>
              </>
            )
          }
        </Modal.Body>
        <Modal.Footer className={styles.footer}>
            <Button onClick={this.onConfirm}>
              {isCancel(errorCode) ? TranslateMessage('MursionPortal.OK') : TranslateMessage('MursionPortal.Button.Refresh')}
            </Button>
        </Modal.Footer>
      </A11yModal>
    );
  }

  private onHide = () => this.props.onHide && this.props.onHide();

  private onConfirm = () => {
    const { onConfirm, errorCode } = this.props;
    const isCancelBtn = isCancel(errorCode);
    return onConfirm && onConfirm(isCancelBtn);
  };

}

export default injectIntl(ErrorModal);
